import React, { useEffect } from 'react';
import { Divider, Link } from '@paypalcorp/pp-react';
import { OTP_CODE, SEND_OTP } from '../common/views';
export default ({ authEventHandler, isAutoOtp, isPomaUser = false, localizedContent, logger, options, setView }) => {
    useEffect(() => {
        logger.track('try_another_way_rendered');
        authEventHandler({
            event: 'tryAnotherWayPageRendered',
        });
    }, []);
    return (React.createElement("div", { style: { textAlign: 'center' } },
        React.createElement("h4", { style: { marginBottom: '16px' } }, localizedContent('tryAnotherWay')),
        React.createElement(Link, { onClick: () => {
                setView(isAutoOtp ? OTP_CODE : SEND_OTP);
            } }, localizedContent('tryOneTimeCode')),
        React.createElement(Divider, { style: { margin: '16px 0' } }),
        React.createElement(Link, { onClick: () => {
                authEventHandler({
                    event: isPomaUser ? 'isPomaUser' : 'userWantsToTryPassword',
                });
            } }, isPomaUser ? localizedContent('setupPassword') : localizedContent('loginWithPassword')),
        !options.signupRequired && (React.createElement(React.Fragment, null,
            React.createElement(Divider, { style: { margin: '16px 0' } }),
            React.createElement(Link, { onClick: () => {
                    authEventHandler({
                        event: 'userOptedOut',
                    });
                } }, localizedContent('checkoutAsGuest'))))));
};
